import React, { useState, useEffect, useRef, useLayoutEffect } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import cn from 'classnames';

import Tag from '../../components/UIkit/Tag';
import NavigationArrow from '../../components/SVG/NavigationArrow';
import { DigitalPlatformSections1 } from '../../components/DigitalPlatform1/constants';
import { IProduct } from '../../components/DigitalPlatform/items/1MonitoringConstants';
import Button from '../../components/UIkit/Button';
import { StoreContext } from '../../store';
import SmoothScrollWrapper from '../../utils/SmoothScrollWrapper';
import ErrorPage from '../ErrorPage/ErrorPage';
// import style from './ProductPage.module.css';
import ItemDP from '../../components/DigitalPlatform/items/ItemDP';
import MonitoringDP from '../../components/DigitalPlatform/items/1Monitoring';
import AnaliticsDP from '../../components/DigitalPlatform/items/2Analitics';
import RaportDP from '../../components/DigitalPlatform/items/3Raport';
import AccountingToolsDP from '../../components/DigitalPlatform/items/5AccountingTools';
import PlanDP from '../../components/DigitalPlatform/items/6Plan';
import WellDP from '../../components/DigitalPlatform/items/7Well';
import CostsDP from '../../components/DigitalPlatform/items/4Costs';
import TrajectoryDP from '../../components/DigitalPlatform/items/8Trajectory';
import Header from '../../components/Layout/Header/Header';
import { LocationState } from '../HomePage';
import { ID_SECTION } from '../../store/constants';
import Footer from '../../components/Layout/Footer';

function ProductPage() {
  const { contactUs, video } = React.useContext(StoreContext);
  const { enName } = useParams<{ enName: string }>();
  const [curProduct, setCurProduct] = useState(DigitalPlatformSections1.find(item => item.EnName === enName));

  // NOTE: при уходе со страницы по кнопке "Назад" в мобильной версии возвращается к платформе
  useEffect(() => {
    sessionStorage.setItem('mobileScrollTo', ID_SECTION.PLATFORM.to);
  }, []);

  useEffect(() => {
    setCurProduct(DigitalPlatformSections1.find(item => item.EnName === enName));
  }, [enName]);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [curProduct]);

  if (!curProduct) {
    return <ErrorPage />;
  }
  const mas = [MonitoringDP, TrajectoryDP, AnaliticsDP, RaportDP, CostsDP, AccountingToolsDP, PlanDP, WellDP];
  const isValidId = curProduct.Id >= 0 && curProduct.Id < mas.length;
  // const InfoComponent = mas[curProduct.Id];
  const InfoComponent = isValidId ? mas[curProduct.Id] : null;

  return (
    <>
      <Header isOtherPage />
      <SmoothScrollWrapper>
        {InfoComponent && <InfoComponent item={curProduct.Product} name={curProduct.Name} id={curProduct.Id} />}
        {/* <ItemDP
          item={curProduct.Product}
          name={curProduct.Name}
          id={curProduct.Id}
        /> */}
        <Footer isOtherPage />
      </SmoothScrollWrapper>
    </>
  );
}

export default ProductPage;
